import * as XLSX from "xlsx";

export const downloadDataAsCSV = (data: any, filename = "data.csv") => {
  if (!data || !data.length) return;

  const headers = Object.keys(data[0]);

  const csvRows = [
    headers.join(","),
    ...data.map((row: any) =>
      headers.map((field) => {
        if(field === "submissions" || field === "errors" || field === "quantity")
        {
          return JSON.stringify(row[field] ? row[field].toLocaleString() : "")
        }
        return JSON.stringify(row[field] ?? "")
      }).join(","),
    ),
  ];

  const csvString = csvRows.join("\n");

  const blob = new Blob([csvString], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("download", filename);
  a.click();
};

export const downloadDataAsXLSX = (
  rows: any,
  filename: string = "data.xlsx",
) => {
  const worksheet = XLSX.utils.json_to_sheet(rows);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

  XLSX.writeFile(workbook, filename);
};
